// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { ArrowRightIcon, AcademicCapIcon } from '@heroicons/react/24/solid';

// const EnterSchoolId = () => {
//   const [schoolId, setSchoolId] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!schoolId.trim()) {
//       setError('Enter a valid School ID.');
//       return;
//     }

//     setLoading(true);
//     setError('');

//     try {
//       const res = await fetch(`/api/schools/get?schoolId=${schoolId.trim()}`);
//       const data = await res.json();

//       if (!data.success) {
//         setError(data.message || 'School not found.');
//         return;
//       }

//       navigate(`/school/${schoolId.trim()}`);
//     } catch (err) {
//       console.error(err);
//       setError('Something went wrong. Please try again later.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="w-full py-4 px-4 flex justify-center">
//       <div className="w-full max-w-3xl bg-slate-900/70 backdrop-blur-md border border-slate-700 shadow-lg rounded-xl px-6 py-4">

//         <form
//           onSubmit={handleSubmit}
//           className="flex flex-col md:flex-row items-center justify-between gap-4"
//         >
//           <span className="flex items-center gap-2 text-white text-sm md:text-base font-medium whitespace-nowrap">
//             <AcademicCapIcon className="h-5 w-5 text-indigo-400" />
//             Get your school:
//           </span>

//           <input
//             type="text"
//             placeholder="Enter School ID"
//             value={schoolId}
//             onChange={(e) => {
//               setSchoolId(e.target.value.toUpperCase());
//               setError('');
//             }}
//             className="flex-1 min-w-0 px-4 py-2 rounded-lg bg-slate-800 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400 text-sm"
//           />

//           <button
//             type="submit"
//             disabled={loading}
//             className="px-5 py-2 flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 transition duration-200 rounded-lg text-white text-sm font-semibold shadow-md disabled:opacity-50"
//           >
//             {loading ? (
//               <svg
//                 className="animate-spin h-4 w-4 text-white"
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 24 24"
//               >
//                 <circle
//                   className="opacity-25"
//                   cx="12"
//                   cy="12"
//                   r="10"
//                   stroke="currentColor"
//                   strokeWidth="4"
//                 ></circle>
//                 <path
//                   className="opacity-75"
//                   fill="currentColor"
//                   d="M4 12a8 8 0 018-8v8H4z"
//                 ></path>
//               </svg>
//             ) : (
//               <>
//                 Go <ArrowRightIcon className="h-4 w-4" />
//               </>
//             )}
//           </button>
//         </form>

//         {error && (
//           <p className="text-red-500 text-xs md:text-sm mt-2 text-center">
//             {error}
//           </p>
//         )}
//       </div>
//     </section>
//   );
// };

// export default EnterSchoolId;


import React, { useState } from 'react';
import { ArrowRightIcon, AcademicCapIcon } from '@heroicons/react/24/solid';

const EnterSchoolId = () => {
  const [schoolId, setSchoolId] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!schoolId.trim()) {
      setError('Enter a valid School ID.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const normalizedId = schoolId.trim().toUpperCase();
      const res = await fetch(`${BACKEND_URL}/api/v1/getSchoolUrlById/${normalizedId}`);

      const data = await res.json();

      if (!data.success || !data.schoolUrl) {
        setError(data.message || 'School not found.');
        return;
      }

      console.log(data.schoolUrl);

      // ✅ Open the school site in a new tab
      window.open(data.schoolUrl, '_blank');
    } catch (err) {
      console.error(err);
      setError('Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="w-full py-4 px-4 flex justify-center">
      <div className="w-full max-w-3xl bg-slate-900/70 backdrop-blur-md border border-slate-700 shadow-lg rounded-xl px-6 py-4">

        <form
          onSubmit={handleSubmit}
          className="flex flex-col md:flex-row items-center justify-between gap-4"
        >
          <span className="flex items-center gap-2 text-white text-sm md:text-base font-medium whitespace-nowrap">
            <AcademicCapIcon className="h-5 w-5 text-indigo-400" />
            Get your school:
          </span>

          <input
            type="text"
            placeholder="Enter School ID"
            value={schoolId}
            onChange={(e) => {
              setSchoolId(e.target.value.toUpperCase());
              setError('');
            }}
            className="flex-1 min-w-0 px-4 py-2 rounded-lg bg-slate-800 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400 text-sm"
          />

          <button
            type="submit"
            disabled={loading}
            className="px-5 py-2 flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 transition duration-200 rounded-lg text-white text-sm font-semibold shadow-md disabled:opacity-50"
          >
            {loading ? (
              <svg
                className="animate-spin h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
            ) : (
              <>
                Go <ArrowRightIcon className="h-4 w-4" />
              </>
            )}
          </button>
        </form>

        {error && (
          <p className="text-red-500 text-xs md:text-sm mt-2 text-center">
            {error}
          </p>
        )}
      </div>
    </section>
  );
};

export default EnterSchoolId;
